import "./assets/css/fonts.css";
import "./assets/css/global.css";

import React from "react";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { BrowserRouter as Router } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import AdminRoutes from "./AdminRoutes";
import Redirect from "./pages/Redirect";
import { BLUE_PRIMARY } from "./utils/const";

const rtlTheme = createTheme({
  direction: "rtl",
  margin: "0",
  padding: "0",
  typography: {
    fontFamily: [
      "Vazir",
      "Roboto",
      "Helvetica Neue",
      "Arial",
      "sans-serif",
    ].join(","),
  },
  palette: {
    primary: {
      main: BLUE_PRIMARY,
      darker: "#1abb82",
    },
    secondary: {
      main: "#00cccc",
    },
  },
});

const App = () => {
  React.useLayoutEffect(() => {
    document.body.setAttribute("dir", "rtl");
    document.body.setAttribute("padding", "0");
    document.body.setAttribute("margin", "0");
  }, []);

  return (
    <ThemeProvider theme={rtlTheme}>
      <Router>
        <Switch>
          <Route
            path="/admin/login"
            exact
            render={(props) => <Login {...props} />}
          />
          <Route path="/admin" render={(props) => <AdminRoutes {...props} />} />
          <Route path="/" render={(props) => <Redirect {...props} />} />
          <Route render={NotFound} />
        </Switch>
      </Router>
    </ThemeProvider>
  );
};

export default App;
